import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import API_URL from '../../config/api';

export const fetchProgressService = createAsyncThunk(
	'dashboard/fetchProgressService',
	async (_, thunkAPI) => {
		try {
			const token = JSON.parse(atob(localStorage.getItem('token') || '""'));
			const response = await axios.get(
				`${API_URL}/api/Dashboard/porcentagem-progresso`,
				{
					headers: {
						Authorization: `Bearer ${token}`,
					},
				}
			);
			return response.data;
		} catch (error) {
			return thunkAPI.rejectWithValue(
				error.response?.data || 'Erro ao buscar progresso'
			);
		}
	}
);

const progressSlice = createSlice({
	name: 'progressService',
	initialState: {
		data: null,
		status: 'idle',
		error: null,
	},
	reducers: {},
	extraReducers: builder => {
		builder
			.addCase(fetchProgressService.pending, state => {
				state.status = 'loading';
				state.error = null;
			})
			.addCase(fetchProgressService.fulfilled, (state, action) => {
				state.status = 'succeeded';
				state.data = action.payload;
				state.error = null;
			})
			.addCase(fetchProgressService.rejected, (state, action) => {
				state.status = 'failed';
				state.error = action.payload;
			});
	},
});

export default progressSlice.reducer;
